"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.updatePageOffset_E76660v1 = updatePageOffset_E76660v1;
exports.updateMapPageOffset_E76660v1 = updateMapPageOffset_E76660v1;
exports.updateListPageOffset_E76660v1 = updateListPageOffset_E76660v1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:19:55Z                      #

// ##############################################################

function updatePageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        "@class": data["@class"] ? data["@class"] : 'PageOffsetVO'
    });

    return result;
}

function updateMapPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updatePageOffset_E76660v1(data[key]);
    });
    return result;
}

function updateListPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePageOffset_E76660v1);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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